import React, { Component } from "react";
import HomeWorkCard from "../../Components/HomeWork/HomeWorkCard";
import Header from "../../Components/MainLayout/Header";
import axios from "axios";
import { connect } from "react-redux";
import noData from "../../Assets/img/noData.png";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class HomeWork extends Component {
  state = { homework: [], loading: true, fakeData: [1, 2, 3, 4] };

  componentDidMount() {
    this.fetch({
      school: this.props.user.user.school.id,
      status: true,
      session: this.props.user.session.id,
      for_class: this.props.user.student_class.id,
      for_section: this.props.user.student_section.id,
      page: 1,
    });
  }

  fetch = (params = {}) => {
    this.setState({ loading: true });
    axios
      .get(`/api/studenthomework`, {
        params: {
          ...params,
        },
      })
      .then((res) => {
        this.setState({
          homework: res.data,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  };

  render() {
    return (
      <div>
        <Header to="/home" title="Home Work" />
        <div className="container pt-3">
          {this.state.loading
            ? this.state.fakeData?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="border p-3 shadow-sm rounded-lg mb-3"
                  >
                    <Skeleton count={2} />
                    <Skeleton width={200} />
                  </div>
                );
              })
            : null}

          {this.state.homework.length !== 0 && this.state.loading === false
            ? this.state.homework?.map((item, index) => {
                return (
                  <div key={index} className="mb-3">
                    <HomeWorkCard
                      circle={
                        item.subject
                          ? item.subject.subject.substring(0, 2)
                          : "Un"
                      }
                      subject={item.subject ? item.subject.subject : "Unknown"}
                      teacher={item.user ? item.user.first_name : "Admin"}
                      AssHeading={item.homework_title}
                      submissionDate={`${
                        (new Date(item.submission_date).getDate() < 10
                          ? "0"
                          : "") + new Date(item.submission_date).getDate()
                      }-${
                        (new Date(item.submission_date).getMonth() + 1 < 10
                          ? "0"
                          : "") +
                        (new Date(item.submission_date).getMonth() + 1)
                      }-${new Date(item.submission_date).getFullYear()}`}
                      uploadDate={`${
                        (new Date(item.homework_date).getDate() < 10
                          ? "0"
                          : "") + new Date(item.homework_date).getDate()
                      }-${
                        (new Date(item.homework_date).getMonth() + 1 < 10
                          ? "0"
                          : "") +
                        (new Date(item.homework_date).getMonth() + 1)
                      }-${new Date(item.homework_date).getFullYear()}`}
                      description={item.description}
                      marks={item.marks}
                      file={item.file}
                    />
                  </div>
                );
              })
            : null}

          {this.state.homework.length === 0 && this.state.loading === false ? (
            <div className="px-5 py-5">
              <img className="w-100 mt-5" src={noData} alt="No Data Found" />
              <p className="text-center th-14 th-bold mt-5">No Homework!</p>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(HomeWork);
